import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const endpoints = {
  event: () => api.get("/event").then((r) => r.data),
  miniSalons: () => api.get("/mini-salons").then((r) => r.data),
  miniSalon: (slug) => api.get(`/mini-salons/${slug}`).then((r) => r.data),
  sponsors: () => api.get("/sponsors").then((r) => r.data),
  judges: () => api.get("/judges").then((r) => r.data),
  categories: () => api.get("/categories").then((r) => r.data),
  schedule: () => api.get("/schedule").then((r) => r.data),
  news: () => api.get("/news").then((r) => r.data),
  gallery: () => api.get("/gallery").then((r) => r.data),
  floorPlan: () => api.get("/floor-plan").then((r) => r.data),
  ticketTiers: () => api.get("/ticket-tiers").then((r) => r.data),
  cars: (params) => api.get("/cars", { params }).then((r) => r.data),
  car: (id) => api.get(`/cars/${id}`).then((r) => r.data),
  leaderboard: (params) => api.get("/leaderboard", { params }).then((r) => r.data),
  announcements: () => api.get("/announcements").then((r) => r.data),
};
